import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Text, Image, Absolute } from 'rebass';
import { defaultProps } from 'recompose';
import styled from 'styled-components';
import QuoteLeft from 'react-icons/lib/fa/quote-left';
import QuoteRight from 'react-icons/lib/fa/quote-right';
import theme from '../../themes';

const QUOTES_PROPS = {
  size: 28,
  color: theme.colors.orange,
};

const Container = styled(Flex)`
  border: 1px solid ${theme.colors.greyLight};
`;

const Rectangle = defaultProps({
  py: 3,
  px: 3,
})(Flex);

const Quote = styled(Box)`
  line-height: 1.3;
  font-family: ${theme.sansSerif};
`;

const Author = styled(Rectangle)`
  position: relative;
  border-top: 1px solid ${theme.colors.greyLight};
  line-height: 1.5;
`;

const ProfileImage = styled(Box)`
  width: 70px;
  height: 70px;
  background: ${theme.colors.white};
  border: 1px solid ${theme.colors.greyLight};

  &, > img {
    border-radius: 100%;
  }
`;

const Testimonial = ({ quote, name, role, image }) => (
  <Container
    column
    mb={4}
  >
    <Rectangle mb={2}>
      <Box w="15%">
        <QuoteLeft {...QUOTES_PROPS} />
      </Box>
      <Quote
        px={2}
        f={3}
      >
        {quote}
      </Quote>
      <Flex
        w="15%"
        justify="flex-end"
      >
        <QuoteRight {...QUOTES_PROPS} />
      </Flex>
    </Rectangle>
    <Author py={3} px={3} column bg="greyExtraLight">
      {
        image &&
          <Absolute top right mt="-22px" mr={3}>
            <ProfileImage p={1}>
              <Image src={image} />
            </ProfileImage>
          </Absolute>
      }
      <Text bold>{name}</Text>
      <Text>{role}</Text>
    </Author>
  </Container>
);

Testimonial.propTypes = {
  quote: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  image: PropTypes.string,
};

Testimonial.defaultProps = {
  image: null,
};

export default Testimonial;



// WEBPACK FOOTER //
// ./src/app/components/testimonial/index.js